function veslNoUnicode(toastr) {
	return {
		restrict: "A",
		require: "ngModel",
		link(scope, element) {
			element.on("keyup paste", function(e) {
				const pastedData = (e.clipboardData && e.clipboardData.getData("text")) || null;
				if(!/^[ -~]*$/.test(pastedData)) {
					e.preventDefault();
					toastr && toastr.error(`The following unicode characters can not be pasted: ${pastedData.match(/[^ -~]/g).join("")}`);
				}
				const content = this.value;
				if(!/^[ -~]*$/.test(content))
					//regex matches all ASCII characters except for backspace
					this.value = content.replace(/[^ -~]/g, "");
			});
		}
	};
}

export default angular.module("vesl.behaviors.vesl-no-unicode", []).directive("veslNoUnicode", veslNoUnicode).name;
